import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      marginBottom: '2rem',
      color: '#14171A',
      fontSize: '1.5rem',
    },
    contentBoxs: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      marginBottom: '0.5rem',
      gap: '1rem',
    },
    boxInput: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      border: '1px solid #e0e0e0',
      borderRadius: '8px',
      padding: '15px',
      width: '140px',
      height: '140px',
      cursor: 'pointer',
      position: 'relative',
      overflow: 'hidden',
    },
    selectedBox: {
      border: '1px solid #2196f3',
      '& .MuiTypography-root': {
        color: '#2196f3',
      },
    },
    labelTop: {
      position: 'absolute',
      top: '10px',
      fontSize: '16px',
      textAlign: 'center',
      width: '100%',
      padding: '0 5px',
      right: 4,
    },
    iconContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      width: '100%',
      padding: '25px 15px 10px',
    },
    horizontalChek: {
      '& svg path': {
        fill: '#2196f3',
      },
    },
    verticalChek: {
      '& svg path': {
        fill: '#2196f3',
      },
    },
    fileIcon: {
      maxWidth: '50px',
      maxHeight: '50px',
      width: 'auto',
      height: 'auto',
      objectFit: 'contain',
    },
    checkIcon: {
      position: 'absolute',
      bottom: '5px',
      right: '5px',
      color: '#2196f3',
    },
    hiden: {
      display: 'none',
    },
    buttonsContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '10px',
    },
    divider: {
      position: 'absolute',
      marginTop: '10px',
      top: '30px',
      width: '95%',
      height: '1px',
      backgroundColor: '#e0e0e0',
      right: 4,
    },

    contentButtons: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      marginBottom: '0.75rem',
      '& button': {
        borderRadius: '0.625rem',
        '&:first-child': {
          marginRight: '0.625rem',
        },
      },
    },
    add: {
      paddingRight: '1.75rem',
      paddingLeft: '1.75rem',
      background: '#0094FF',
      color: '#fff',
      ' &:hover': {
        backgroundColor: '#0094FF',
        filter: 'brightness(0.9)',
      },
    },
    notAdd: {
      paddingRight: '1.75rem',
      paddingLeft: '1.75rem',
      background: '#E1E8ED',
      color: '#AAB8C2',
    },
    closeButton: {
      padding: 2,
    },
  }),
);

export default useStyles;
